<template>
  <div class="invoice-header--block-header row" v-if="invoice">
    <div class="col-md-6 invoice-header--block-left">
      <span class="text-primary">
        <Spinner v-if="loader" :theme="primary" class="mx-auto d-block" />
        <template v-else>
          <img
            v-if="isDefaultLogo.length && !isDefaultLogo[1].value.status"
            :src="isDefaultLogo[0].value.image"
            style="width: 170px; border-radius: 5px;"
            alt=""
          />
          <IconHeadroom v-else />
        </template>
      </span>
      <div
        class="address colorGray mt-4"
        v-if="invoice_address"
        v-html="invoice_address.value.address"
      >
        <a href="mailto:hello@loft.ph">hello@loft.ph</a>
      </div>
      <div class="customer">
        <p class="colorGray font-weight-bold">
          Bill To
        </p>
        <div class="customer-details" v-if="invoice.User">
          <p>{{ invoice.User.firstName + " " + invoice.User.lastName }}</p>
          <p>{{ invoice.User.email }}</p>
          <p>{{ invoice.User.mobileNo }}</p>
        </div>
      </div>
    </div>
    <div
      class="col-md-6 invoice-header--block-right invoice-header--block-header--normal"
    >
      <div class="invoice-header--code-label">
        <h1 class="mb-5">Invoice</h1>
        <p>{{ invoice.code }}</p>
      </div>
      <div class="mt-30">
        <p class="colorGray font-weight-bold">Balance Due</p>
        <p>
          {{ convertToMoney(invoice.totalAmount) }}
        </p>
      </div>
      <div class="mt-30">
        <p class="colorGray font-weight-bold">Invoice Date</p>
        <p>{{ formatDate(invoice.createdAt) }}</p>
        <template v-if="invoice.dueAt">
          <p class="colorGray">Due Date:</p>
          <p>{{ formatDate(invoice.dueAt) }}</p>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { IconHeadroom } from "@/components/icons";
import { filter } from "lodash";

const Spinner = () => import("@/components/Spinner");

export default {
  components: {
    IconHeadroom,
    Spinner
  },
  props: {
    address: {
      type: [String],
      default: null
    },
    user: {
      type: [Object],
      default: null
    },
    invoice: {
      type: [Object],
      default: null
    }
  },
  computed: {
    options() {
      return this.$store.state.concierge.optionsList.data;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  async created() {
    let searchKey = "invoice.main";
    await this.$store.dispatch("fetchOptions", searchKey);
    this.loader = false;
    let options = this.$store.state.concierge.optionsList.data;
    this.invoice_address = filter(options, val => {
      return val.label == "Invoice Address";
    })[0];

    await this.$store.dispatch("fetchOptions", "defaultlogo");
    this.isDefaultLogo = this.options;
  },
  data() {
    return {
      isLoading: true,
      invoice_address: "",
      isDefaultLogo: [
        {
          value: {
            image: null
          }
        },
        {
          value: {
            status: false
          }
        }
      ],
      loader: true
    };
  },
  methods: {
    convertToMoney(amount) {
      return (
        "Php " + amount.toLocaleString("en-US", { minimumFractionDigits: 2 })
      );
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice-header {
  .colorGray {
    color: #4c4c4c;
  }
  &--code-label {
    h1 {
      font-family: "Arial";
      font-size: 32px;
      font-weight: 700;
    }
    p {
      font-size: 17px;
    }
  }
  &--block {
    padding: 30px;
    &-left,
    &-right {
      p {
        font-family: "Arial";
        color: #4c4c4c;
        margin: 0;
      }
    }
    &-left {
      text-align: left;
      .address {
        /deep/ p {
          font-family: "Arial";
          color: #4c4c4c;
          margin: 0;
        }
        margin-bottom: 30px;
      }
    }
    &-right {
      text-align: right;
    }
    &-header {
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      &--normal {
        font-size: 18px;
      }
    }
    .address,
    .customer {
      color: #4c4c4c;
      font-size: 16px;
    }
    .font-weight-bold {
      font-weight: 900;
    }
  }
}
</style>
